import React, {useState, useEffect} from 'react'
import { Button } from '@mui/material'
import AdjustIcon from '@mui/icons-material/Adjust';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp';
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

function 
DTMFActionButtons({actions, onClick}) {
  const getIcon = (name) => {
    switch (name) {
      case 'Adjust':
        return <AdjustIcon />  
      case 'ControlPoint':
        return <ControlPointIcon />  
      case 'AddCircleOutlineIcon':
        return <AddCircleOutlineIcon />  
      case 'RemoveCircleOutlineIcon':
        return <RemoveCircleOutlineIcon />  
      case 'ArrowCircleUpIcon':
        return <ArrowCircleUpIcon />  
      case 'ArrowCircleDownIcon':
        return <ArrowCircleDownIcon />  
      case 'CheckCircleOutlineIcon':
        return <ArrowCircleDownIcon />  
    
      default:
        return <AdjustIcon />  
    }
  }

  return (
    <div className='live-call-dtmf-action-buttons'>
        {actions.map((action, i) => {
          return (
            <Button
              fullWidth
              variant='contained'
              style={{justifyContent: "flex-start"}}
              key={i}
              startIcon={getIcon(action.icon)}
              onClick={() => onClick(action.tone)}
            >
              {action.label}
            </Button>
          )
        })}
    </div>
  )
}

export default 
DTMFActionButtons